import { Component, OnInit } from '@angular/core';
import { MessageService, Message } from 'primeng/api';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { CaseService } from 'src/app/services/case.service';
import { StatsService } from 'src/app/services/stats.service';
import { ReportService } from 'src/app/services/report.service';
import * as appData from '../shared/appData';
import * as theGlobals from 'src/app/shared/globals';


@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
})

export class DashboardComponent implements OnInit {
    reportCols: any[];
    chartOptions: any;  // options used to customize chart layout, etc
    chartSections: [];
    myChartSection: any;
    allSectionsData: any;   // contains the data for ALL sections
    valChartOptions: any;
    assessorChartOptions: any;
    expCasesChartOptions: any;
    //
    expCasesData: any;
    totalExpiringCases: any;
    chartData: any;
    //
    pieChartData: any;
    dynoChartData: any;
    valueDiffData: any;
    pieValueDiffData: any;
    assessorData: any;
    complexCaseData: any;
    totalComplexCases: any;
    totalComplexNeedInitMeeting: any;
    totalComplexNeedNotice: any;
    //
    chartType = 'bar';
    dsColors = ['red', 'black', 'green', 'blue', 'aqua', 'pink', 'violet', 'yellow', 'grey', '#1C39BB', '#FFE5B4', 'purple', '#0095B6', '#DE5D83', 'gold', '#0047AB', '#E0B0FF', 'magenta', 'aqua'];
    yearList: number[];
    cityList: string[];
    assessorList: any[];
    myYear = 0;
    displayState: any = {
        workingDiv: false,
        gridDiv: false,
        chartDiv: false,
        chartDivDyno: false,
        valDiffDiv: false
    };
    workingCounter = 0;

    excelCols = appData.excelColList;  // column names used when exporting to Excel
    showChartMode = theGlobals.setEnv().showDashboardMode;  // determines if charts are displayed, and which ones

    constructor(private utilService: UtilitiesService, private caseService: CaseService,
                private dictService: DictionaryService, private statsService: StatsService,
                private reportService: ReportService,  private messageService: MessageService) {}

    ngOnInit() {
        this.utilService.doAudit('Charts init...');
        // localStorage.removeItem(this.cookieService.get('userName') + '-lastApplicant');
        this.myYear = (new Date()).getFullYear() - 1;
        this.populateYearList();
        this.reportCols = [
            { field: 'repDesc', header: 'Report Description' },
        ];
        this.chartOptions = {
            title: {
                display: true,
                text: 'Case Statistics',
                fontSize: 16
            },
            legend: {
                position: 'top'
            }
        };
        this.valChartOptions = {
            title: {
                display: true,
                text: 'Value Difference Stats',
                fontSize: 16
            },
            legend: {
                position: 'top'
            }
        };
        this.assessorChartOptions = {
          title: {
            display: true,
            text: 'Assessor Stats',
            fontSize: 16
          },
          legend: {
            position: 'top'
          }
        };
        this.expCasesChartOptions = {
          title: {
            display: true,
            text: 'Expiring Cases',
            fontSize: 16
          },
          legend: {
            position: 'top'
          }
        }

        this.chartData = {};
        this.pieChartData = {};
        this.valueDiffData = {};
        this.assessorData = {};
        this.expCasesData = {};
        //
        const dicts = this.dictService.getDictionaries(); // get all dictionaries
        this.utilService.doAudit(dicts, 'dictionaries');
        this.cityList = dicts.cityChoices;
        this.cityList.push('Other');
        //
        this.dictService.getAssessorList().subscribe(data => {
          this.utilService.doAudit(data, 'assessors:');
          this.assessorList = [];
          if (data) {
            // tslint:disable-next-line:prefer-for-of
            for (let ai = 0; ai < data.length; ai++) {
              this.assessorList.push(data[ai].name);
            }
            this.assessorList.push('Other');
          }
          this.utilService.doAudit(this.assessorList, 'assessor list:');
          this.displayState.chartDiv = true;
        });
        this.workingCounter = 0;  // use this counter to determine if all the calls to get counters have been satisfied
        this.displayState.workingDiv = true;
        this.runExpiringCasesReport();
        this.runComplexCaseReport();
        if (this.showChartMode > 0) {
          // this.runComplexCaseReport();
          this.runCaseStatsReport();
        } else {
          this.workingCounter++;
        }
        //
        // this.getChartDataL();   // get the data from local storage
    }
    refreshDashboard() {
      this.workingCounter = 0;  // use this counter to determine if all the calls to get counters have been satisfied
      this.displayState.workingDiv = true;
      this.runExpiringCasesReport();
      this.runComplexCaseReport();
      if (this.showChartMode > 0) {
        // this.runComplexCaseReport();
        this.runCaseStatsReport();
      } else {
        this.workingCounter++;
      }
    }
    runComplexCaseReport() {
      this.utilService.doAudit('Getting complex cases','');
      this.statsService.findComplexCasesForTimer().subscribe(data => {
        if (data) {
          this.utilService.doAudit(data,'response from findComplexCasesForTimer:');
          this.complexCaseData = data;
          let needInit = data.filter(c=> {
            return c.hasInitialMeeting == false? c: null;
          });
          this.totalComplexNeedInitMeeting = needInit.length;
          let needNotice = data.filter(c=> {
            return c.hasInitialMeeting == true && c.hasNotice == false? c: null;
          });
          this.totalComplexNeedNotice = needNotice.length;
          this.utilService.doAudit(needNotice,'need notice:');
          this.utilService.doAudit(needInit, 'need init:');
          this.totalComplexCases = data.length; // # of complex cases meeting timer criteria
        }
        this.workingCounter++;
        if (this.workingCounter == 3) {
          this.displayState.workingDiv = false;
        }
      });
    }
    printInitComplexCaseReport() {
      // redirect to the complex case report
      if (this.totalComplexNeedInitMeeting < 1) {
        this.showToast({ key: 'info', severity: 'info', detail: 'No cases to display!', summary: 'Info' });
        return;
      }
      this.displayState.workingDiv = true;

      this.reportService.getComplexCaseList().subscribe(data => {
        this.utilService.doAudit('got response from complex case list:');
        if (data) {
          // const myBlob = new Blob(myData, {type: 'application/pdf'} );
          const myUrl = URL.createObjectURL(data);
          window.open(myUrl, '_blank');
          URL.revokeObjectURL(myUrl);
        }
        this.displayState.workingDiv = false;

      });
    }
    printNeedNoticeComplexCaseReport() {
      // redirect to the complex case report - need notice
      if (this.totalComplexNeedNotice < 1) {
        this.showToast({ key: 'info', severity: 'info', detail: 'No cases to display!', summary: 'Info' });
        return;
      }
      alert('will redirect to the Complex Case Need Notice Report... not ready yet!');
      return;
    }

  printExpirationListReport() {
    if (this.totalExpiringCases < 1) {
      alert('No cases to display');
      return;
    }
    let sortBy = "CaseNum";
    this.displayState.workingDiv = true;

    this.utilService.doAudit('calling expiration list function...');
    this.reportService.getExpirationList(sortBy).subscribe(data => {
      this.utilService.doAudit('got response from expiration list:');
      if (data) {
        // const myBlob = new Blob(myData, {type: 'application/pdf'} );
        const myUrl = URL.createObjectURL(data);
        window.open(myUrl, '_blank');
        URL.revokeObjectURL(myUrl);
      }
      this.displayState.workingDiv = false;

    });
  }

  // this method is run ONLY once, during init...
  runExpiringCasesReport() {
    this.utilService.doAudit('Getting expiring cases count','');
    // initialize the graph definition, dataset
    this.statsService.getExpiringCasesCount().subscribe(data => {
      if (data > -1) {
        this.utilService.doAudit(data,'response from expiring cases count...');
        this.totalExpiringCases = data;
        let expArr = [];
        expArr.push(data);
        this.expCasesData = {
          labels: ['Totals'],
          datasets: [
            {
              label: 'Expiring Cases',
              data: expArr,
              fill: false,
              borderColor: '#4bc0c0',
              backgroundColor: '#42A5F5',
            },
          ]
        }
        this.utilService.doAudit(expArr,'expiring cases count array:');
      }
      this.workingCounter++;
      if (this.workingCounter == 3) {
        this.displayState.workingDiv = false;
      }
    })
  }
    runCaseStatsReport() {
      if (!this.myYear) {
        alert('Please select a Roll Year!');
        return;
      }
      // this.getReportData(this.myYear);
      this.getReportDataFromView(this.myYear);
    }

    // get application/case data from the vwCaseListingInfo view
    getReportDataFromView(caseYear: number): void {
      const srcObj = {
        p0: '',
        p1: '',
        p2: ''
      };
      this.utilService.doAudit(srcObj, 'report search:');
      this.displayState.workingDiv = true;
      this.displayState.chartDiv = false;
      // get list of cases based on the Property Roll Year (NOT when they were filed, i.e. case # based)
      this.statsService.searchAppsByCaseYear(caseYear).subscribe(data => {
        this.utilService.doAudit(data, 'results from searchApplicationsByYear:');
        this.allSectionsData = data;
        this.chartOptions.title.text = 'Case Statistics for ' + caseYear + ' - by Status';
        this.valChartOptions.title.text = 'Value Differences for ' + caseYear;
        let caseObj: any = null;
        let city = '';
        let closedStat: boolean;
        let cityIdx = -1;
        let appraiserName = '';
        let appraiserId = 0;
        let assessIdx: any;
        const openCase = [];
        const otherCase = [];
        //
        const openCaseAssessor = [];
        const otherCaseAssessor = [];

        // initialize city counters for each dataset (openCase, otherCase, etc)
        const caseIds = [];
        const caseIdsByCity = [];
        for (let i = 0; i < this.cityList.length; i++) {
          openCase[i] = 0;
          otherCase[i] = 0;
        }
        for (let i = 0; i < this.assessorList.length; i++) {
          openCaseAssessor[i] = 0;
          otherCaseAssessor[i] = 0;
        }
        // update city counters for each dataset...
        for (let i = 0; i < data.length; i++) {
          caseObj = data[i];
          city = data[i].propCity;
          closedStat = data[i].closedStatus;
          appraiserId = data[i].assessorId;
          appraiserName = data[i].appraiserName;
          //
          // assessIdx = this.assessorList.filter(o => o.id === assessorId);  // if assessorList is an array of Objects!
          assessIdx = this.assessorList.indexOf(appraiserName);
          // this.utilService.doAudit(assessIdx, 'assessIdx for ' + appraiserName + ':');
          if (assessIdx < 0) {
            assessIdx = this.assessorList.length - 1; // default to "Other"
          }
          //
          cityIdx = this.cityList.indexOf(city);
          if (cityIdx < 0) {
            cityIdx = this.cityList.length - 1; // default to "Other"
          }
          if (closedStat === false) {
            openCase[cityIdx]++;
            openCaseAssessor[assessIdx]++;
          } else {
            otherCase[cityIdx]++;
            otherCaseAssessor[assessIdx]++;
          }
          caseIds.push(data[i].applicationId);
          caseIdsByCity.push(cityIdx);
        }
        this.utilService.doAudit(openCase, 'open cases totals');
        this.utilService.doAudit(otherCase, 'other cases totals');
        this.chartSections = [];
        this.myChartSection = 1;
        const tDS = [
          {
            label: 'Open Cases',
            data: openCase,
            fill: false,
            borderColor: '#4bc0c0',
            backgroundColor: '#42A5F5',
          },
          {
            label: 'Closed Cases',
            data: otherCase,
            fill: false,
            borderColor: '#9CCC65',
            backgroundColor: 'darkgreen',
          }
        ];

        this.chartData = {
          labels: this.cityList,
          datasets: tDS
        };

        this.dynoChartData = this.chartData;

        this.pieChartData = {
          labels: this.cityList,
          datasets: [
            {
              label: 'Open Cases',
              data: openCase,
              fill: false,
              borderColor: '#4bc0c0',
              backgroundColor: '#42A5F5',
            },
            {
              label: 'Closed Cases',
              data: otherCase,
              fill: false,
              borderColor: '#9CCC65',
              backgroundColor: 'darkgreen',
            }
          ]
        };
        this.assessorData = {
          labels: this.assessorList,
          datasets: [
            {
              label: 'Open Cases',
              data: openCaseAssessor,
              fill: false,
              borderColor: '#4bc0c0',
              backgroundColor: '#42A5F5',
            },
            {
              label: 'Closed Cases',
              data: otherCaseAssessor,
              fill: false,
              borderColor: '#9CCC65',
              backgroundColor: 'darkgreen',
            }
          ]
        };

        this.displayState.gridDiv = false;
        this.displayState.chartDiv = true;
        this.workingCounter++;
        if (this.workingCounter == 3) {
          this.displayState.workingDiv = false;
        }
        // this.displayState.chartDivDyno = true;
        this.getValueDiffData(caseIds, caseIdsByCity);
      });
    }
  getValueDiffData(caseIds: any[], caseIdsByCity: any[]) {
    this.utilService.doAudit(caseIds, 'case ids:');
    this.utilService.doAudit(caseIdsByCity, 'case ids, by city:');
    //
    const data = this.allSectionsData;  // source of data - ALL cases found for specified Roll Year
    //
    this.utilService.doAudit(data, 'data:');
    //
    const valDiffByCity = [];
    let cityIdx = -1;
    for (let i = 0; i < this.cityList.length; i++) {
      valDiffByCity[i] = 0;
    }
    //
    this.initChartDataset();
    // initialize all the cities to zero
    let caseObj: any = null, appId = '', appCtr = 0, city = '', valDiff = 0;
    for (let i = 0; i < data.length; i++) {
      caseObj = data[i];
      appId = caseObj.applicationId;
      valDiff = this.calcValDiff(caseObj);
      // this.utilService.doAudit(valDiff, 'valDiff for appId: ' + appId);
      appCtr = caseIds.indexOf(appId);
      // this.utilService.doAudit(appCtr, 'appCtr:');
      if (appCtr > -1) {
        cityIdx = caseIdsByCity[appCtr];
      } else {
        cityIdx = this.cityList.length - 1; // default to "Other"
      }
      valDiffByCity[cityIdx] = Number(valDiffByCity[cityIdx] + valDiff);
    }
    this.utilService.doAudit(valDiffByCity, 'valDiffByCity:');
    const tDS2 = [
      {
        label: 'Value Diff (in dollars)',
        data: valDiffByCity,
        fill: false,
        borderColor: '#4bc0c0',
        backgroundColor: '#42A5F5',
      },
    ];

    this.valueDiffData = {
      labels: this.cityList,
      datasets: tDS2
    };

    this.pieValueDiffData = {
      labels: this.cityList,
      datasets: [
        {
          label: 'Value Diff (in $)',
          data: valDiffByCity,
          fill: false,
          borderColor: '#4bc0c0',
          backgroundColor: '#42A5F5',
        },
      ]
    };

    this.displayState.valDiffDiv = true;
    this.displayState.workingDiv = false;
  }
  initChartDataset() {
    // populate chart data w/ empty dataset...
    const valDiffByCity = [];
    for (let i = 0; i < this.cityList.length; i++) {
      valDiffByCity[i] = 0;
    }
    this.valueDiffData = {
      labels: this.cityList,
      datasets: [
        {
          label: 'Value Diff (in US-dollars)',
          data: valDiffByCity,
          fill: false,
          borderColor: '#4bc0c0',
          backgroundColor: '#42A5F5',
        },
      ]
    };
    this.pieValueDiffData = {
      labels: this.cityList,
      datasets: [
        {
          label: 'Value Diff (in $)',
          data: valDiffByCity,
          fill: false,
          borderColor: '#4bc0c0',
          backgroundColor: '#42A5F5',
        },
      ]
    };
    //
    this.displayState.valDiffDiv = true;
    this.displayState.workingDiv = false;
    return;
  }
    calcValDiff(caseObj: any): any {
      const opinionVal = caseObj.tvOpinion ? caseObj.tvOpinion : 0;
      const appVal = caseObj.tvAssessor ? caseObj.tvAssessor : caseObj.tvApplicant;
      if (appVal && opinionVal) {
        return (appVal - opinionVal);
      } else { return 0; }
    }

    getReportData(caseYear: number) {
        const srcObj = {
            p0: '',
            p1: '',
            p2: ''
        };
        this.utilService.doAudit(srcObj, 'report search:');
        this.displayState.workingDiv = true;
        this.displayState.chartDiv = false;
        // get list of cases based on year they were filed (i.e. case #), NOT the Property Roll Year!
        this.caseService.getCaseListByYear(caseYear).subscribe(data => {
            this.utilService.doAudit(data, 'results from getCaseListByYear:');
            this.allSectionsData = data;
            this.chartOptions.title.text = 'Case Statistics for ' + caseYear + ' - by Status';
            this.valChartOptions.title.text = 'Value Differences for ' + caseYear;
            let caseObj: any = null;
            let city = '', stat = '', cityIdx = -1, statIdx = -1;
            const openCase = [], otherCase = [];
            // initialize city counters for each dataset (openCase, otherCase, etc)
            const caseIds = [], caseIdsByCity = [];
            for (let i = 0; i < this.cityList.length; i++) {
                openCase[i] = 0;
                otherCase[i] = 0;
            }
            // update city counters for each dataset...
            for (let i = 0; i < data.length; i++) {
                caseObj = data[i];
                city = data[i].city;
                stat = data[i].status;
                cityIdx = this.cityList.indexOf(city);
                if (cityIdx < 0) {
                    cityIdx = this.cityList.length - 1; // default to "Other"
                }
                if (stat === 'Open') {
                    openCase[cityIdx]++;
                } else {
                    otherCase[cityIdx]++;
                }
                caseIds.push(data[i].id);
                caseIdsByCity.push(cityIdx);

            }
            // this.utilService.doAudit(openCase, 'open cases totals');
            // this.utilService.doAudit(otherCase, 'other cases totals');
            this.chartSections = [];
            this.myChartSection = 1;
            const tDS = [
                {
                    label: 'Open Cases',
                    data: openCase,
                    fill: false,
                    borderColor: '#4bc0c0',
                    backgroundColor: '#42A5F5',
                },
                {
                    label: 'Closed Cases',
                    data: otherCase,
                    fill: false,
                    borderColor: '#9CCC65',
                    backgroundColor: 'darkgreen',
                }
            ];

            this.chartData = {
                labels: this.cityList,
                datasets: tDS
            };

            this.dynoChartData = this.chartData;

            this.pieChartData = {
                labels: this.cityList,
                datasets: [
                    {
                        data: openCase,
                        backgroundColor: this.dsColors,
                        hoverBackgroundColor: this.dsColors
                    },
                ]
            };

            this.displayState.gridDiv = false;
            this.displayState.chartDiv = true;
            // this.displayState.chartDivDyno = true;
            this.getValueDiffDataOLD(caseIds, caseIdsByCity);
        });
    }
    onChangeType() {
        this.utilService.doAudit(this.chartType, 'changed type to:');
        if (this.chartType !== 'pie') {
            this.dynoChartData = Object.assign({}, this.chartData);
            this.valueDiffData = Object.assign({}, this.valueDiffData);
            this.assessorData = Object.assign({}, this.assessorData);
            // this.expCasesData = Object.assign({}, this.expCasesData);
        } else {
            this.dynoChartData = Object.assign({}, this.pieChartData);
            this.valueDiffData = Object.assign({}, this.pieValueDiffData);
            this.assessorData = Object.assign({}, this.assessorData);
            // this.expCasesData = Object.assign({}, this.expCasesData);
        }
    }

    selectData(event) {
        this.utilService.doAudit(event, 'data selected:');
        this.utilService.doAudit(this.chartData.datasets[event.element._datasetIndex].data[event.element._index], 'item selected:');
    }

    selectValData(event) {
        this.utilService.doAudit(event, 'data selected:');
        this.utilService.doAudit(this.valueDiffData.datasets[event.element._datasetIndex].data[event.element._index], 'item selected:');
    }
    selectAssessorData(event) {
      this.utilService.doAudit(event, 'data selected:');
      this.utilService.doAudit(this.assessorData.datasets[event.element._datasetIndex].data[event.element._index], 'item selected:');
    }
    selectExpireCasesData(event) {
      this.utilService.doAudit(event, 'data selected:');
      this.utilService.doAudit(this.expCasesData.datasets[event.element._datasetIndex].data[event.element._index], 'item selected:');

    }
    populateYearList() {
      const curYr = new Date().getFullYear();
      const yrList = [];
      for (let yr = curYr; yr > (curYr - 20); yr--)
      {
        yrList.push(yr);
      }
      this.yearList = yrList;
    }

  exportExcel() {
      this.utilService.exportExcel2(this.allSectionsData, [this.excelCols], 'cases-for-' + this.myYear);
      // this.utilService.exportExcel2(this.valueDiffData, [['ID', 'City', 'ValueDiff']], 'value-diff-list');
      return;
  }

  // Toaster/Message-related methods
  showToast(msg: Message) {
    this.messageService.clear('toast');
    this.messageService.add(msg);
  }

  showInfo(myMsg: Message) {
    this.messageService.clear('info');
    this.messageService.add(myMsg);
  }

  clearAll() {
    this.messageService.clear();
  }

  onSelectReport(rep: any) {
    this.utilService.doAudit(rep, 'selected rep:');
    this.getReportData(this.myYear);
  }

  getValueDiffDataOLD(caseIds: any[], caseIdsByCity: any[]) {
    this.utilService.doAudit(caseIds, 'case ids:');
    this.utilService.doAudit(caseIdsByCity, 'case ids, by city:');
    //
    const valDiffByCity = [];
    let cityIdx = -1;
    for (let i = 0; i < this.cityList.length; i++) {
      valDiffByCity[i] = 0;
    }
    //
    const valObs = this.caseService.getValuesForCases(caseIds);
    this.utilService.doAudit(valObs, 'valObs');
    if (valObs == null) {
      // populate chart data w/ empty dataset...
      this.valueDiffData = {
        labels: this.cityList,
        datasets: [
          {
            label: 'Value Diff (in US-dollars)',
            data: valDiffByCity,
            fill: false,
            borderColor: '#4bc0c0',
            backgroundColor: '#42A5F5',
          },
        ]
      };

      this.pieValueDiffData = {
        labels: this.cityList,
        datasets: [
          {
            label: 'Value Diff (in $)',
            data: valDiffByCity,
            fill: false,
            borderColor: '#4bc0c0',
            backgroundColor: '#42A5F5',
          },
        ]
      };
      //
      this.displayState.valDiffDiv = true;
      this.displayState.workingDiv = false;
      return;
    }
    valObs.subscribe(data => {
      this.utilService.doAudit(data, 'results from getValuesForCases:');
      // initialize all the cities to zero

      let caseObj: any = null, appId = '', appCtr = 0, city = '', valDiff = 0;
      for (let i = 0; i < data.length; i++) {
        caseObj = data[i];
        appId = data[i].applicationId;
        valDiff = data[i].valueDifference;

        appCtr = caseIds.indexOf(appId);
        this.utilService.doAudit(appCtr, 'appCtr:');
        if (appCtr > -1) {
          cityIdx = caseIdsByCity[appCtr];
        } else {
          cityIdx = this.cityList.length - 1; // default to "Other"
        }
        valDiffByCity[cityIdx] = Number(valDiffByCity[cityIdx] + valDiff);
      }
      this.utilService.doAudit(valDiffByCity, 'valDiffByCity:');
      const tDS2 = [
        {
          label: 'Value Diff (in dollars)',
          data: valDiffByCity,
          fill: false,
          borderColor: '#4bc0c0',
          backgroundColor: '#42A5F5',
        },
      ];

      this.valueDiffData = {
        labels: this.cityList,
        datasets: tDS2
      };

      this.pieValueDiffData = {
        labels: this.cityList,
        datasets: [
          {
            label: 'Value Diff (in $)',
            data: valDiffByCity,
            fill: false,
            borderColor: '#4bc0c0',
            backgroundColor: '#42A5F5',
          },
        ]
      };

      this.displayState.valDiffDiv = true;
      this.displayState.workingDiv = false;
    });
  }

  onChangeSection() {
    const sectNum = this.myChartSection;
    this.utilService.doAudit(sectNum, 'changing report section to:');
    this.utilService.doAudit(this.allSectionsData[sectNum], 'section data:');
    this.displayState.workingDiv = true;
    // this.displayState.chartDiv = false;
    this.chartData = this.allSectionsData[sectNum];
    this.displayState.workingDiv = false;
    this.displayState.chartDiv = true;
  }
  getPieChartDataL() {
    this.pieChartData = {
      labels: ['A', 'B', 'C'],
      datasets: [
        {
          data: [300, 50, 100],
          backgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56'
          ],
          hoverBackgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56'
          ]
        }]
    };
  }

  getChartDataL() {
    // populate chartData array w/ test data...
    // let tLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
    const tLabels = this.cityList;
    const tDS = [
      {
        label: 'First Dataset',
        data: [65, 59, 80, 81, 56, 55, 40, 0, 15, 20, 150, 10],
        fill: false,
        borderColor: '#4bc0c0',
        backgroundColor: '#42A5F5',
      },
      {
        label: 'Second Dataset',
        data: [28, 48, 40, 19, 86, 27, 90, 20, 25, 35, 90, 120],
        fill: false,
        borderColor: '#565656',
        backgroundColor: '#9CCC65',
      }
    ];
    this.chartData = {
      labels: tLabels ,
      datasets: tDS
    };

    this.pieChartData = {
      labels: ['A', 'B', 'C'],
      datasets: [
        {
          data: [300, 50, 100],
          backgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56'
          ],
          hoverBackgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56'
          ]
        }]
    };
    this.chartOptions = {
      title: {
        display: true,
        text: 'Case Statistics for Year: ' + this.myYear,
        fontSize: 16,
      }
    };
  }


}
